import { render, staticRenderFns } from "./MenuExterno.vue?vue&type=template&id=55a2860e&scoped=true"
import script from "./MenuExterno.vue?vue&type=script&lang=js"
export * from "./MenuExterno.vue?vue&type=script&lang=js"
import style0 from "./MenuExterno.vue?vue&type=style&index=0&id=55a2860e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a2860e",
  null
  
)

export default component.exports